import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ew-input-language',
  templateUrl: './input-language.component.html',
  styleUrl: './input-language.component.scss',
})
export class InputLanguageComponent implements OnChanges, OnInit {
  @Input() label: string = 'shared:selectLanguage';
  @Input() width: string = '160px';
  @Input() required: boolean = true;
  @Output() valueChanged = new EventEmitter<any>();

  value!: string;
  language!: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.language = changes['value'].currentValue;
    }
  }

  ngOnInit(): void {
    const language = localStorage.getItem('lang');
    if (language) {
      this.language = language;
    }
  }
}
